import { setWelcome } from '../services/localStorage';

export const BRANDFOLDER = 'BRANDFOLDER';
export const BRANDFOLDERS = 'BRANDFOLDERS';
export const ATTACHMENTS = 'ATTACHMENTS';
export const GETTING_STARTED = 'GETTING_STARTED';
export const WELCOME = 'WELCOME';

export const showBrandfolder = () => ({
  type: BRANDFOLDER
});

export const showBrandfolders = () => ({
  type: BRANDFOLDERS
});

export const showAttachments = () => ({
  type: ATTACHMENTS
});

export const showGettingStarted = () => dispatch => {
  setWelcome();
  dispatch({
    type: GETTING_STARTED
  });
};

export const showWelcome = () => ({
  type: WELCOME
});



// WEBPACK FOOTER //
// ./src/actions/page.js